import { createRootRoute, Link, Outlet } from '@tanstack/react-router';
import { OfflineBanner } from '@/components/OfflineBanner';

/**
 * Root layout route — renders the top-level Outlet.
 * All routes are children of this route.
 * No authentication logic here; auth guard lives in _app.tsx.
 *
 * OfflineBanner is mounted here (not in a specific route) so the offline
 * indicator is visible on every route, including the cached shell served by
 * the service worker's navigateFallback while offline (PWA-02).
 */
export const Route = createRootRoute({
  component: () => (
    <>
      <OfflineBanner />
      <Outlet />
    </>
  ),
  notFoundComponent: () => (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-4 text-center">
      <p className="text-2xl font-semibold tracking-tight text-slate-900">Broke or Not</p>
      <p className="text-sm text-slate-500">This page doesn&apos;t exist.</p>
      <Link to="/" className="font-medium text-blue-600 underline hover:text-blue-700">
        Back to calendar
      </Link>
    </div>
  ),
});
